import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { FormWrapper } from '../../Hoc/elements';
import PBMark from '../Brand/PBMark';

export const AuthPage = styled.div`
  width: 100%;
  min-height: calc(100vh - 4.75rem);
  display: grid;
  place-items: center;
  padding: clamp(1rem, 4vw, 3.5rem);
  background:
    radial-gradient(circle at 12% 12%, rgba(192, 163, 117, 0.2), transparent 25rem),
    radial-gradient(circle at 88% 88%, rgba(0, 0, 0, 0.05), transparent 28rem),
    linear-gradient(145deg, #faf9f6, #f1eee8);
`;

export const AuthCard = styled(FormWrapper)`
  position: relative;
  width: min(100%, 46rem);
  margin: 0 auto;
  padding: clamp(1.35rem, 4vw, 2.75rem);
  border: 1px solid rgba(17, 17, 17, 0.1);
  border-radius: clamp(1.25rem, 3vw, 1.8rem);
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 1.6rem 4rem rgba(0, 0, 0, 0.12);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0 0 auto;
    height: 0.28rem;
    background: linear-gradient(90deg, #111 0 72%, var(--color-accent) 72% 100%);
  }
`;

const BrandRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  align-self: flex-start;
  margin-bottom: 1.35rem;

  > div {
    display: grid;
    line-height: 1.15;
  }

  strong {
    color: #111;
    font-size: 0.96rem;
    font-weight: 900;
    letter-spacing: -0.03em;
  }

  span {
    margin-top: 0.2rem;
    color: #77716a;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
  }
`;

export const AuthBrand = ({ subtitle = 'Plateforme locale de confiance' }) =>
  React.createElement(
    BrandRow,
    null,
    React.createElement(PBMark, {
      size: '2.65rem',
      shadow: true,
      alt: 'Le Petit Boulot',
    }),
    React.createElement(
      'div',
      null,
      React.createElement('strong', null, 'Le Petit Boulot'),
      React.createElement('span', null, subtitle),
    ),
  );

export const AuthRoleSelectorLabel = styled.p`
  margin: 0 0 0.65rem;
  color: #171717;
  font-size: 0.82rem;
  font-weight: 900;
`;

export const AuthRoleSelector = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.55rem;

  @media (max-width: 36rem) {
    grid-template-columns: 1fr;
  }
`;

export const AuthRoleChoice = styled(Link)`
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem;
  border: 1px solid ${({ ['data-active']: active }) => (active === 'true' ? '#111' : '#ded9d0')};
  border-radius: 1rem;
  color: ${({ ['data-active']: active }) => (active === 'true' ? '#fff' : '#171717')};
  background: ${({ ['data-active']: active }) => (active === 'true' ? '#111' : '#fff')};
  text-decoration: none;
  box-shadow: ${({ ['data-active']: active }) => (active === 'true' ? '0 0.85rem 1.8rem rgba(0, 0, 0, 0.16)' : 'none')};
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-2px);
    border-color: ${({ ['data-active']: active }) => (active === 'true' ? '#111' : 'var(--color-accent)')};
    box-shadow: 0 0.8rem 1.7rem rgba(0, 0, 0, 0.11);
  }

  &:focus-visible {
    outline: 3px solid rgba(192, 163, 117, 0.42);
    outline-offset: 2px;
  }
`;

export const AuthRoleIcon = styled.span`
  width: 2.55rem;
  height: 2.55rem;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 0.8rem;
  color: ${({ ['data-active']: active }) => (active === 'true' ? '#111' : '#fff')};
  background: ${({ ['data-active']: active }) => (active === 'true' ? 'var(--color-accent)' : '#111')};
  font-size: 0.9rem;
  font-weight: 950;
`;

export const AuthRoleText = styled.span`
  min-width: 0;
  display: grid;
  gap: 0.15rem;

  strong {
    font-size: 0.91rem;
    font-weight: 950;
    letter-spacing: -0.02em;
  }

  span {
    color: inherit;
    font-size: 0.72rem;
    line-height: 1.35;
    opacity: 0.72;
  }
`;

export const AuthRoleState = styled.span`
  padding: 0.28rem 0.48rem;
  border-radius: 999px;
  color: ${({ ['data-active']: active }) => (active === 'true' ? '#111' : '#655f56')};
  background: ${({ ['data-active']: active }) => (active === 'true' ? 'var(--color-accent)' : '#f1eee8')};
  font-size: 0.62rem;
  font-weight: 950;
  white-space: nowrap;

  @media (max-width: 26rem) {
    display: none;
  }
`;

export const AuthKicker = styled.span`
  margin-bottom: 0.65rem;
  color: var(--color-accentDark);
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const AuthTitle = styled.h1`
  max-width: 18ch;
  margin-bottom: 0.8rem;
  color: var(--color-mainDark);
  font-size: clamp(1.85rem, 5vw, 2.7rem);
  line-height: 1.05;
  letter-spacing: -0.05em;
`;

export const AuthDescription = styled.p`
  max-width: 62ch;
  margin-bottom: 1.8rem;
  color: var(--color-muted);
  font-size: 0.96rem;
  line-height: 1.65;
`;

export const AuthFieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  > * {
    min-width: 0;
  }

  @media (max-width: 36rem) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

export const AuthNotice = styled.div`
  display: grid;
  gap: 0.25rem;
  margin: 0.15rem 0 0.35rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid #e6dfd3;
  border-radius: 0.9rem;
  color: #50493f;
  background: #faf7f1;
  font-size: 0.78rem;
  line-height: 1.5;

  strong {
    color: #171717;
    font-size: 0.8rem;
    font-weight: 900;
  }
`;

export const AuthSignInPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.4rem;
  padding: 0.9rem 1rem;
  border: 1px solid #ddd7cd;
  border-radius: 1rem;
  background: #f7f4ee;

  > div {
    min-width: 0;
    display: grid;
    gap: 0.15rem;
  }

  strong {
    color: #171717;
    font-size: 0.86rem;
    font-weight: 950;
  }

  span {
    color: #6c665d;
    font-size: 0.73rem;
    line-height: 1.4;
  }

  @media (max-width: 32rem) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const AuthSignInLink = styled(Link)`
  min-height: 2.55rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.62rem 1rem;
  border: 1px solid #111;
  border-radius: 999px;
  color: #fff;
  background: #111;
  font-size: 0.78rem;
  font-weight: 950;
  text-decoration: none;
  white-space: nowrap;
  transition: transform 160ms ease, background 160ms ease;

  &:hover {
    transform: translateY(-1px);
    background: #2a2a2a;
  }

  &:focus-visible {
    outline: 3px solid rgba(192, 163, 117, 0.42);
    outline-offset: 2px;
  }
`;

export const AuthFooter = styled.p`
  margin: 0.25rem 0 0;
  color: var(--color-muted);
  text-align: center;
  font-size: 0.88rem;
`;

export const AuthLink = styled(Link)`
  color: var(--color-main);
  font-weight: 800;
  text-decoration: none;

  &:hover {
    color: var(--color-mainDark);
    text-decoration: underline;
  }
`;

export const AuthLinkButton = styled.button`
  padding: 0;
  border: 0;
  color: var(--color-main);
  background: transparent;
  font-weight: 800;
  cursor: pointer;

  &:hover {
    color: var(--color-mainDark);
    text-decoration: underline;
  }
`;
